import { useAtomValue } from "jotai";
import { useEffect } from "react";

import BottomDrawer from "components/BottomDrawer";
import Button from "components/Button";
import { ErrorIcon } from "components/Icons/Error";
import { NoInternetIcon } from "components/Icons/NoInternet";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { selectedDamagedPartsAtom } from "atoms/damageReview";
import { useCheckpoint } from "hooks/useCheckpoint";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useCompleteSession } from "hooks/useCompleteSession";
import { usePageRouting } from "hooks/usePageRouting";
import { Checkpoint } from "types/Checkpoint";

import { DamagedPartsList } from "./DamagedPartsList";

export const DamageReview = () => {
  const targetReached = useCheckpoint(Checkpoint.DAMAGED_PARTS_SUBMITTED);

  const { currentProgressStep, onTrackAndNext } = usePageRouting();
  const { t } = useClientTranslation();
  const damagedParts = useAtomValue(selectedDamagedPartsAtom);
  const { completeSession, completeSessionLoading, sessionCompleted, completeSessionError } = useCompleteSession();

  useEffect(() => {
    if (sessionCompleted) {
      onTrackAndNext({
        name: "Damage review",
        properties: {
          numberOfParts: damagedParts.length,
          partNames: damagedParts.join(", "),
        },
      })();
    }
  }, [damagedParts, onTrackAndNext, sessionCompleted]);

  return (
    <PageLayout
      currentStep={currentProgressStep}
      title={t("damage_review.header")}
      dataTestId="damageReview"
      forceContinue={targetReached}
      bottomButtons={
        <Button loading={completeSessionLoading} onClick={completeSession}>
          {t("global.continue")}
        </Button>
      }
    >
      <DamagedPartsList />

      <BottomDrawer
        isOpen={!!completeSessionError}
        closeOnClickOutside={false}
        heading={navigator.onLine ? t("error.api_load.header") : t("offline.header")}
        headingIcon={navigator.onLine ? <ErrorIcon /> : <NoInternetIcon />}
        callToActionText={"Retry"}
        callToActionOnClick={completeSession}
      >
        <Text sizeVariant="md">{navigator.onLine ? t("offline.error.instruction") : t("offline.instruction")}</Text>
      </BottomDrawer>
    </PageLayout>
  );
};
